
export const PRODUCTS = [
  { id: 'sku_jetpack', name: 'Jetpack 2.0', price: 199.0 },
  { id: 'sku_cloak', name: 'Invisibility Cloak', price: 349.0 },
  { id: 'sku_translator', name: 'Universal Translator', price: 129.0 },
  { id: 'sku_gravity', name: 'Pocket Gravity', price: 79.0 }
];
